import { css } from "@emotion/core";

const sdmsLink = false;

const override = css`
  position: fixed;
  margin: 5px;
  clear: both;
  left: 40%;

  :before {
    content: "";
    display: block;
    position: fixed;

    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const defalutreduxState = {
  Menu: {
    Controlrights: [],
  },
  audit: {
    auditoption: [],
  },
  SheetCreation: {
    VersionBar: false,
    Sheetrender: true,
    Draggeddata: {},
    SpreadData: {
      menuclick: false,
      menuid: -1,
      SpreadDatasource: JSON.stringify(
        JSON.parse(
          '{"activeSheet":"Sheet1","sheets":[{"name":"Sheet1","rows":[],"columns":[],"selection":"A1:A1","activeCell":"A1:A1","frozenRows":1,"frozenColumns":0,"showGridLines":true,"gridLinesColor":null,"mergedCells":[],"hyperlinks":[],"defaultCellStyle":{"fontFamily":"Arial","fontSize":"12"},"drawings":[]}],"names":[],"columnWidth":64,"rowHeight":20}'
        )
      ),
      Sheetview: false,
      stopview: false,
    },
    sheetInfo: [],
    SheetName: "",
    SheetNameAs: "",
    IsSaveAssheet: false,
    SheetCode: 0,
    IsNewsheet: false,
    loading: false,
    MenuOption: 0,
    AuditUrl: "",
    AuditObject: [],
    AuditPassfunction: null,
    AuditFailfunction: null,
    AuditCancelfunction: undefined,
    DocumentType: 0,
    DocumentSteps: 1,
    MultiDocumentView: [{ Content: "<div></div>" }],
    MultiDocumentDetils: [{ Name: "", Description: "" }],
    MultiDocMenuoption: 0,
    DocumentContent: "<div></div>",
    Data: [],
    Sheetversion: 0,
    lstestcode: [],
    Sheetparameters: [],
    File: undefined,
    saveA: false,
    SaveEditA: false,
    SaveopenA: false,
    auditSave: false,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    approvelEnable: false,
    Isnameopen: false,
    savename: null,
    closenamepop: null,
    workflowexpanded: false,
    transactionexpanded: false,
    treeexpanded: false,
    workflow: false,
    transaction: false,
    version: false,
    savedisable: true,
  },
  Sheetview: {
    Draggeddata: {},
    SpreadData: {
      menuclick: false,
      menuid: -1,
      SpreadDatasource: [],
      Sheetview: true,
      stopview: false,
      IsTreeView: false,
      ViewCompleteorder: false,
      ViewCompleteorderid: -1,
      Parameters: [],
    },
    SheetName: "",
    SheetCode: 0,
    selectedfile: {},
    lastVersion: 99999,
    Testcode: "",
    stopDisabled: false,
    IsShowDesigner: false,
    ModifiedSheetdata: {},
    OrderTestcode: "",
    OrderTestName: "",
    MethodID: "",
    InstrumentID: "",
    MenuOption: 0,
    orderDetailsclassName: "clsdisplayblock",
    KenodclassName: "clsDisplaynone",
    filteredPendingorder: "",
    filteredPendingTest: "",
    filteredCompleteorder: "",
    filteredCompleteTest: "",
    Assigntestfor: 0,
    MaterialTestcode: "",
    MaterialTestName: "",
    MaterialSheetName: "",
    MaterialSheetCode: 0,
    PendingActive: "clsactivetab",
    CompletedActive: "",
    AssignedActive: "",
    MyActive: "",
    PendingPanelshow: "clsdisplayblock",
    CompletedPanelshow: "clsDisplaynone",
    pendingDateFrom: new Date().setMonth(new Date().getMonth() - 1),
    pendingDateTo: new Date().setDate(new Date().getDate()),
    CompleteDateFrom: new Date().setMonth(new Date().getMonth() - 1),
    CompleteDateTo: new Date().setDate(new Date().getDate()),
    SelectedTest: {},
    Projectcode: "",
    Projectusercode: null,
    Samplecode: "",
    FlowName: {},
    unApprovedfile: null,

    Evalsavevisb: true,
    Excelsavevisb: true,
    Researchvisible: true,
    ELNregistervis: true,
    LIMSprocessvis: true,
    compsavevisible: true,
    pendsavevisible: true,
    pendvisible: true,
    compvisible: true,
    LIMSorderVisible: true,
    ELNorderVisible: true,
    ExcelorderVisible: true,
    DocumentorderVisible: true,
    ResearchorderVisible: true,
    IsOrderLocked: 0,
    IsOrderLockedbyUser: 0,
    IsFinalworkflow: 0,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    Orderclosebuttonvisible: true,
    showinfo: false,
    showattachment: false,
    workflowexpanded: false,
    transactionexpanded: false,
    Islargefilesize: false,
    SearchContent: "",
    Contentsearchvalue: 1,
    CompSearchContent: "",
    ContentCompsearchvalue: 1,
    sdmsattachement: [],
    pendingorderaudit: false,
  },
  sheet: {
    ParseFields: [],
    timerID: 0,
  },
  KendoSpread: {
    Isrender: true,
    IsLoader: false,
    kendoSpread: null,
    MaterialTypeArray: [],
    MaterialCategoryArray: [],
    MaterialArray: [],
    MaterialSectionArray: [],
    InventoryArray: [],
    GradeArray: [],
    InstrumentType: [],
    InstrumentCategory: [],
    InstrumentSection: [],
    InstrumentName: [],
    MaterialInventoryTransaction: [],
    Parameter: "",
    Parametervalid: "",
    Linktosheet: false,
    Linksheetcode: {},
    LinkBatchID: {},
    LinkView: "clsDisplaynone",
    chemicalview: "clsDisplaynone",
    LinkSheetValid: "",
    LinkBatchValid: "",
    Linkedsheetvalue: [],
    LinkedViewon: -1,
    popchart: null,
    orderid: -1,
    orderDetails: {},
    RunParameters: [],
    SheetName: "",
    SheetCode: 0,
    Draggedonview: false,
    lastVersion: 99999,
    filesamplecode: 0,
    AuditUrl: "",
    AuditObject: [],
    AuditPassfunction: null,
    AuditFailfunction: null,
    AuditParameters: {},
    optionvalue: "",
    Dyndatafromsheet: "1",
    Dyndatacolumn: "1",
    Dyndatarangefrom: "1",
    Repeatfieldoncapture: false,
    Repeatview: "clsDisplaynone",
    DynGroponsheet: 0,
    Iscopyfieldopen: false,
    Currentsheetfields: [],
    Ismetavalueopen: false,
    metatags: {},
    parameterview: "clsDisplaynone",
    Optionview: "clsDisplaynone",
    Dyncomboview: "",
    Optionvalid: "",
    viewchart: false,
    charts: [],
    plates: [],
    tags: [],
    fields: [],
    viewtags: false,
    currenttagindex: -1,
    tagCount: 0,
    currentchartindex: -1,
    chartXAxis: [],
    chartYAxis: [],
    capturex: 0,
    capturey: 0,
    currentchart: {
      // chartName: "chart",
      // Iscontrolchart: false,
      seriescount: 1,
      chartype: "line",
      series: [
        {
          seriesIndex: 1,
          seriesName: "series 1",
          mode: "line",
          // marker: { color: "red" },
          points: [],
          titleVlaue: "",
          lagendVlaue: "",
        },
      ],
    },
    addpointrow: false,
    selectedxPoint: -1,
    selectedyPoint: -1,
    currentchartview: null,
    CurrentSeriesindex: 0,
    CurrentSeriesoncobmo: 0,

    SheetDataSource: [],
    SheetValue: {},
    OrderDataSource: [],
    OrderValue: {},
    Sheetdata: {},
    chartType: [
      { name: "line" },
      { name: "bar" },
      { name: "pie" },
      { name: "scatter" },
      { name: "line+bar" },
      { name: "regression" }
    ],
    regressiondata: [{ name: "exponential" },
    { name: "logarithmic" },
    { name: "polynomial" }],
    SeriesMode: [
      { name: "line" },
      { name: "bar" },
      // { name: "pie" },
      { name: "scatter" },
      // { name: "scatterLine" }
      // { name: "text+lines" },
      // { name: "text+lines+markers" },
      // { name: "none" },
      // { name: "gauge" },
      // { name: "number" },
      // { name: "delta" },
      // { name: "number+delta" },
      // { name: "gauge+number" },
      // { name: "gauge+number+delta" },
      // { name: "gauge+delta" }
    ],
    SeriesStyle: [{ name: "normal" }, { name: "smooth" }],
    chartcolorview: false,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    Completedorder: false,
    processType: 0,
    Sampleselect: false,
    File: undefined,
    LsrepositoriesDropData: [],
    LsrepositoriesdataDropData: [],
    Data: [],
    Repositoryuseddata: [],
    isconsumable: false,
    consumable: 0,
    Quantityused: 0,
    Quantityrequired: 0,
    temprepositoryData: [],
    singleLsrepositoriesDropData: [],
    editrepository: false,
  },
  KendoSpreadCreate: {
    Isrender: true,
    kendoSpread: null,
    MaterialTypeArray: [],
    MaterialCategoryArray: [],
    MaterialArray: [],
    MaterialSectionArray: [],
    InventoryArray: [],
    GradeArray: [],
    InstrumentType: [],
    InstrumentCategory: [],
    InstrumentSection: [],
    InstrumentName: [],
    MaterialInventoryTransaction: [],
    Parameter: "",
    Parametervalid: "",
    Linktosheet: false,
    Linksheetcode: {},
    LinkBatchID: {},
    LinkView: "",
    LinkSheetValid: "",
    LinkBatchValid: "",
    Linkedsheetvalue: [],
    LinkedViewon: -1,
    popchart: null,
    orderid: -1,
    orderDetails: {},
    RunParameters: [],
    SheetName: "",
    SheetCode: 0,
    Draggedonview: false,
    lastVersion: 99999,
    filesamplecode: 0,
    AuditUrl: "",
    AuditObject: [],
    AuditPassfunction: null,
    AuditFailfunction: null,
    AuditParameters: {},
    optionvalue: "",
    Dyndatafromsheet: "1",
    Dyndatacolumn: "1",
    Dyndatarangefrom: "1",
    Repeatfieldoncapture: false,
    Repeatview: "",
    DynGroponsheet: 0,
    Iscopyfieldopen: false,
    Currentsheetfields: [],
    Ismetavalueopen: false,
    metatags: {},
    parameterview: "",
    Optionview: "",
    Dyncomboview: "",
    Optionvalid: "",
    viewchart: false,
    charts: [],
    plates: [],
    tags: [],
    fields: [],
    viewtags: false,
    currenttagindex: -1,
    tagCount: 0,
    currentchartindex: -1,
    chartXAxis: [],
    chartYAxis: [],
    capturex: 0,
    capturey: 0,
    currentchart: {
      // chartName: "chart",
      // Iscontrolchart: false,
      seriescount: 1,
      chartype: "line",
      series: [
        {
          seriesIndex: 1,
          seriesName: "series 1",
          mode: "line",
          // marker: { color: "red" },
          points: [],
          titleVlaue: "",
          lagendVlaue: "",
        },
      ],
    },
    addpointrow: false,
    selectedxPoint: -1,
    selectedyPoint: -1,
    currentchartview: null,
    CurrentSeriesindex: 0,
    CurrentSeriesoncobmo: 0,

    SheetDataSource: [],
    SheetValue: {},
    OrderDataSource: [],
    OrderValue: {},
    Sheetdata: {},
    chartType: [
      { name: "line" },
      { name: "bar" },
      { name: "pie" },
      { name: "scatter" },
      { name: "line+bar" },
      { name: "regression" }
    ],
    regressiondata: [{ name: "exponential" },
    { name: "logarithmic" },
    { name: "polynomial" }],
    SeriesMode: [
      { name: "line" },
      { name: "bar" },
      // { name: "pie" },
      { name: "scatter" },
      // { name: "scatterLine" }
      // { name: "text+lines" },
      // { name: "text+lines+markers" },
      // { name: "none" },
      // { name: "gauge" },
      // { name: "number" },
      // { name: "delta" },
      // { name: "number+delta" },
      // { name: "gauge+number" },
      // { name: "gauge+number+delta" },
      // { name: "gauge+delta" }
    ],
    SeriesStyle: [{ name: "normal" }, { name: "smooth" }],
    chartcolorview: false,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    Completedorder: false,
    processType: 0,
    Sampleselect: false,
    File: undefined
  },
  Loggeduser: {},
  userworkflow: [],
  navigation: "methodMainMenu",
  fluidPage: false,
  userData: {
    userName: "Administrator",
    role: 1,
    domain: "LocalDB",
    language: "en",
    site: { sitecode: 1, sitename: "Default", status: 1 },
    userSite: 1,
    error: "",
  },
  hideMenu: {},
  masterData: {},
  visibility: true,
  transVisibility: true,
  fieldDetail: {},
  instrumentCategory: 2016, //primary key for 'General'
  saveAuditTrail: false,

  dataGridStatus: "",
  filterColumnName: "",
  searchColumnData: undefined,
  auditStatus: "",
  rawDataText: "",
  loginStatus: "",
  instrawdataurl: "",
  status: "",

  //status:"",
  loginUser: {
    usercode: 1,
    username: "Administrator",
    firstname: "Admin",
    lastname: "Admin",
    email: "admin@agaramtech.com",
    contactno: "4498765432",
    transstatusdetail: {
      transstatusdetailkey: 4,
      transstatus: { transstatuskey: 2, transstatusname: "Users" },
      statusmaster: {
        statuskey: 1,
        statusname: "Active",
        displayname: "Active",
      },
    },
    signImageUrl: null,
    userImageUrl: null,
    userimgname: null,
    signimgname: null,
    status: 0,
    createdby: {
      usercode: 1,
      username: "Administrator",
      firstname: "Admin",
      lastname: "Admin",
    },
    createddate: "2019-07-29T00:00:00Z",
  },
  loginSitePageList: [
    {
      pagekey: 43,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "MethodSetup",
      status: 1,
    },
    {
      pagekey: 44,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "MethodMaster",
      status: 1,
    },
    {
      pagekey: 45,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "Delimiters",
      status: 1,
    },
    {
      pagekey: 46,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "SampleSplit",
      status: 1,
    },
    {
      pagekey: 47,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "ParserSetup",
      status: 1,
    },
    {
      pagekey: 48,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "MethodDelimiter",
      status: 1,
    },
    {
      pagekey: 49,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "GeneralField",
      status: 1,
    },
    {
      pagekey: 51,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "CustomField",
      status: 1,
    },
    {
      pagekey: 52,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "InstrumentCategory",
      status: 1,
    },
    {
      pagekey: 53,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "InstrumentMaster",
      status: 1,
    },
  ],
  loginUserSiteRole: {
    userrolekey: 1,
    usersite: {
      usersitekey: 1,
      users: {
        usercode: 1,
        username: "Administrator",
        firstname: "Admin",
        lastname: "Admin",
        email: "admin@agaramtech.com",
      },
      site: { sitecode: 1, sitename: "Default", status: 1 },
      defaultstatus: 1,
      status: 1,
      createdby: {
        usercode: 1,
        username: "Administrator",
        firstname: "Admin",
        lastname: "Admin",
      },
      createddate: "2019-07-29T00:00:00Z",
    },
    rolepolicy: {
      rolepolicykey: 3,
      role: {
        rolekey: 7,
        rolename: "Administrator",
        description: "Administrator Role",
        site: { sitecode: 1, sitename: "Default", status: 1 },
        status: 0,
        createdby: {
          usercode: 1,
          username: "Administrator",
          firstname: "Admin",
          lastname: "Admin",
        },
        createddate: "2019-11-21T00:00:00Z",
      },
      passcodepolicy: {
        policykey: 1,
        policyname: "Administrator",
        description: "Used for Administrator",
        maxpasscode: 20,
        nooffailedattempt: 3,
      },
      status: 0,
      createdby: {
        usercode: 1,
        username: "Administrator",
        firstname: "Admin",
        lastname: "Admin",
      },
      createddate: "2019-08-19T00:00:00Z",
    },

    passcode: "A@m1n",
    expirydate: "2020-01-13T10:32:57.017Z",
    transstatusdetail: {
      transstatusdetailkey: 4,
      transstatus: { transstatuskey: 2, transstatusname: "Users" },
      statusmaster: {
        statuskey: 1,
        statusname: "Active",
        displayname: "Active",
      },
    },
    clientip: "192.168.0.147",
    defaultstatus: 1,
    status: 1,
    createdby: {
      usercode: 1,
      username: "Administrator",
      firstname: "Admin",
      lastname: "Admin",
    },
    createddate: "2019-08-28T00:00:00Z",
  },
  loginInvalidAttempts: 0,
  isnotactivelogout: false,
  instrumentidparser: [],
  profileimages: [],
  dashboard: {
    orders: [],
    templates: [],
    selectedorder: undefined
  }
};

const initialreduxState = {
  Menu: {
    Controlrights: [],
  },
  audit: {
    auditoption: [],
  },
  SheetCreation: {
    VersionBar: false,
    Draggeddata: {},
    Sheetrender: true,
    SpreadData: {
      menuclick: false,
      menuid: -1,
      SpreadDatasource: JSON.stringify(
        JSON.parse(
          '{"activeSheet":"Sheet1","sheets":[{"name":"Sheet1","rows":[],"columns":[],"selection":"A1:A1","activeCell":"A1:A1","frozenRows":0,"frozenColumns":0,"showGridLines":true,"gridLinesColor":null,"mergedCells":[],"hyperlinks":[],"defaultCellStyle":{"fontFamily":"Arial","fontSize":"12"},"drawings":[]}],"names":[],"columnWidth":64,"rowHeight":20}'
        )
      ),
      Sheetview: false,
      stopview: false,
    },
    sheetInfo: [],
    SheetName: "",
    SheetNameAs: "",
    IsSaveAssheet: false,
    SheetCode: 0,
    IsNewsheet: false,
    loading: false,
    MenuOption: 0,
    AuditUrl: "",
    AuditObject: [],
    AuditPassfunction: null,
    AuditFailfunction: null,
    AuditCancelfunction: undefined,
    DocumentType: 0,
    DocumentSteps: 1,
    MultiDocumentView: [{ Content: "<div></div>" }],
    MultiDocumentDetils: [{ Name: "", Description: "" }],
    MultiDocMenuoption: 0,
    DocumentContent: "<div></div>",
    Data: [],
    Sheetversion: 0,
    lstestcode: [],
    Sheetparameters: [],
    File: undefined,
    saveA: false,
    SaveEditA: false,
    SaveopenA: false,
    auditSave: false,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    approvelEnable: false,
    Isnameopen: false,
    savename: null,
    closenamepop: null,
    workflowexpanded: false,
    transactionexpanded: false,
    treeexpanded: true,
    workflow: false,
    transaction: false,
    version: false,
    savedisable: true,
  },
  Sheetview: {
    Draggeddata: {},
    SpreadData: {
      menuclick: false,
      menuid: -1,
      SpreadDatasource: [],
      Sheetview: true,
      stopview: false,
      IsTreeView: false,
      ViewCompleteorder: false,
      ViewCompleteorderid: -1,
      Parameters: [],
    },
    SheetName: "",
    SheetCode: 0,
    selectedfile: {},
    lastVersion: 99999,
    Testcode: "",
    stopDisabled: false,
    IsShowDesigner: false,
    ModifiedSheetdata: {},
    OrderTestcode: "",
    OrderTestName: "",
    MethodID: "",
    InstrumentID: "",
    MenuOption: 0,
    orderDetailsclassName: "clsdisplayblock",
    KenodclassName: "clsDisplaynone",
    filteredPendingorder: "",
    filteredPendingTest: "",
    filteredCompleteorder: "",
    filteredCompleteTest: "",
    Assigntestfor: 0,
    MaterialTestcode: "",
    MaterialTestName: "",
    MaterialSheetName: "",
    MaterialSheetCode: 0,
    PendingActive: "clsactivetab",
    CompletedActive: "",
    AssignedActive: "",
    MyActive: "",
    PendingPanelshow: "clsdisplayblock",
    CompletedPanelshow: "clsDisplaynone",
    pendingDateFrom: new Date().setMonth(new Date().getMonth() - 1),
    pendingDateTo: new Date().setDate(new Date().getDate()),
    CompleteDateFrom: new Date().setMonth(new Date().getMonth() - 1),
    CompleteDateTo: new Date().setDate(new Date().getDate()),
    SelectedTest: {},
    Projectcode: "",
    Projectusercode: null,
    Samplecode: "",
    FlowName: {},
    unApprovedfile: null,

    Evalsavevisb: true,
    Excelsavevisb: true,
    Researchvisible: true,
    ELNregistervis: true,
    LIMSprocessvis: true,
    compsavevisible: true,
    pendsavevisible: true,
    pendvisible: true,
    compvisible: true,
    LIMSorderVisible: true,
    ELNorderVisible: true,
    ExcelorderVisible: true,
    DocumentorderVisible: true,
    ResearchorderVisible: true,
    IsOrderLocked: 0,
    IsOrderLockedbyUser: 0,
    IsFinalworkflow: 0,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    Orderclosebuttonvisible: true,
    showinfo: false,
    showattachment: false,
    workflowexpanded: false,
    transactionexpanded: false,
    Islargefilesize: false,
    SearchContent: "",
    Contentsearchvalue: 1,
    CompSearchContent: "",
    ContentCompsearchvalue: 1,
    sdmsattachement: [],
    pendingorderaudit: false,
  },
  sheet: {
    ParseFields: [],
    timerID: 0,
  },
  KendoSpread: {
    Isrender: true,
    IsLoader: false,
    kendoSpread: null,
    MaterialTypeArray: [],
    MaterialCategoryArray: [],
    MaterialArray: [],
    MaterialSectionArray: [],
    InventoryArray: [],
    GradeArray: [],
    InstrumentType: [],
    InstrumentCategory: [],
    InstrumentSection: [],
    InstrumentName: [],
    MaterialInventoryTransaction: [],
    Parameter: "",
    Parametervalid: "",
    Linktosheet: false,
    Linksheetcode: {},
    LinkBatchID: {},
    LinkView: "clsDisplaynone",
    chemicalview: "clsDisplaynone",
    LinkSheetValid: "",
    LinkBatchValid: "",
    Linkedsheetvalue: [],
    LinkedViewon: -1,
    popchart: null,
    orderid: -1,
    orderDetails: {},
    RunParameters: [],
    SheetName: "",
    SheetCode: 0,
    Draggedonview: false,
    lastVersion: 99999,
    filesamplecode: 0,
    AuditUrl: "",
    AuditObject: [],
    AuditPassfunction: null,
    AuditFailfunction: null,
    AuditParameters: {},
    optionvalue: "",
    Dyndatafromsheet: "1",
    Dyndatacolumn: "1",
    Dyndatarangefrom: "1",
    Repeatfieldoncapture: false,
    Repeatview: "clsDisplaynone",
    DynGroponsheet: 0,
    Iscopyfieldopen: false,
    Currentsheetfields: [],
    Ismetavalueopen: false,
    metatags: {},
    parameterview: "clsDisplaynone",
    Optionview: "clsDisplaynone",
    Dyncomboview: "",
    Optionvalid: "",
    viewchart: false,
    charts: [],
    plates: [],
    tags: [],
    fields: [],
    viewtags: false,
    currenttagindex: -1,
    tagCount: 0,
    currentchartindex: -1,
    chartXAxis: [],
    chartYAxis: [],
    capturex: 0,
    capturey: 0,
    currentchart: {
      // chartName: "chart",
      // Iscontrolchart: false,
      seriescount: 1,
      chartype: "line",
      series: [
        {
          seriesIndex: 1,
          seriesName: "series 1",
          mode: "line",
          // marker: { color: "red" },
          points: [],
          titleVlaue: "",
          lagendVlaue: "",
        },
      ],
    },
    addpointrow: false,
    selectedxPoint: -1,
    selectedyPoint: -1,
    currentchartview: null,
    CurrentSeriesindex: 0,
    CurrentSeriesoncobmo: 0,

    SheetDataSource: [],
    SheetValue: {},
    OrderDataSource: [],
    OrderValue: {},
    Sheetdata: {},
    chartType: [
      { name: "line" },
      { name: "bar" },
      { name: "pie" },
      { name: "scatter" },
      { name: "line+bar" },
      { name: "regression" }
    ],
    regressiondata: [{ name: "exponential" },
    { name: "logarithmic" },
    { name: "polynomial" }],
    SeriesMode: [
      { name: "line" },
      { name: "bar" },
      // { name: "pie" },
      { name: "scatter" },
      // { name: "scatterLine" }
      // { name: "text+lines" },
      // { name: "text+lines+markers" },
      // { name: "none" },
      // { name: "gauge" },
      // { name: "number" },
      // { name: "delta" },
      // { name: "number+delta" },
      // { name: "gauge+number" },
      // { name: "gauge+number+delta" },
      // { name: "gauge+delta" }
    ],
    SeriesStyle: [{ name: "normal" }, { name: "smooth" }],
    chartcolorview: false,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    Completedorder: false,
    processType: 0,
    Sampleselect: false,
    File: undefined,
    LsrepositoriesDropData: [],
    LsrepositoriesdataDropData: [],
    Data: [],
    Repositoryuseddata: [],
    isconsumable: false,
    consumable: 0,
    Quantityused: 0,
    Quantityrequired: 0,
    temprepositoryData: [],
    singleLsrepositoriesDropData: [],
    editrepository: false,
  },
  KendoSpreadCreate: {
    Isrender: true,
    kendoSpread: null,
    MaterialTypeArray: [],
    MaterialCategoryArray: [],
    MaterialArray: [],
    MaterialSectionArray: [],
    InventoryArray: [],
    GradeArray: [],
    InstrumentType: [],
    InstrumentCategory: [],
    InstrumentSection: [],
    InstrumentName: [],
    MaterialInventoryTransaction: [],
    Parameter: "",
    Parametervalid: "",
    Linktosheet: false,
    Linksheetcode: {},
    LinkBatchID: {},
    LinkView: "",
    LinkSheetValid: "",
    LinkBatchValid: "",
    Linkedsheetvalue: [],
    LinkedViewon: -1,
    popchart: null,
    orderid: -1,
    orderDetails: {},
    RunParameters: [],
    SheetName: "",
    SheetCode: 0,
    Draggedonview: false,
    lastVersion: 99999,
    filesamplecode: 0,
    AuditUrl: "",
    AuditObject: [],
    AuditPassfunction: null,
    AuditFailfunction: null,
    AuditParameters: {},
    optionvalue: "",
    Dyndatafromsheet: "1",
    Dyndatacolumn: "1",
    Dyndatarangefrom: "1",
    Repeatfieldoncapture: false,
    Repeatview: "",
    DynGroponsheet: 0,
    Iscopyfieldopen: false,
    Currentsheetfields: [],
    Ismetavalueopen: false,
    metatags: {},
    parameterview: "",
    Optionview: "",
    Dyncomboview: "",
    Optionvalid: "",
    viewchart: false,
    charts: [],
    plates: [],
    tags: [],
    fields: [],
    viewtags: false,
    currenttagindex: -1,
    tagCount: 0,
    currentchartindex: -1,
    chartXAxis: [],
    chartYAxis: [],
    capturex: 0,
    capturey: 0,
    currentchart: {
      // chartName: "chart",
      // Iscontrolchart: false,
      seriescount: 1,
      chartype: "line",
      series: [
        {
          seriesIndex: 1,
          seriesName: "series 1",
          mode: "line",
          // marker: { color: "red" },
          points: [],
          titleVlaue: "",
          lagendVlaue: "",
        },
      ],
    },
    addpointrow: false,
    selectedxPoint: -1,
    selectedyPoint: -1,
    currentchartview: null,
    CurrentSeriesindex: 0,
    CurrentSeriesoncobmo: 0,

    SheetDataSource: [],
    SheetValue: {},
    OrderDataSource: [],
    OrderValue: {},
    Sheetdata: {},
    chartType: [
      { name: "line" },
      { name: "bar" },
      { name: "pie" },
      { name: "scatter" },
      { name: "line+bar" },
      { name: "regression" }
    ],
    regressiondata: [{ name: "exponential" },
    { name: "logarithmic" },
    { name: "polynomial" }],
    SeriesMode: [
      { name: "line" },
      { name: "bar" },
      // { name: "pie" },
      { name: "scatter" },
      // { name: "scatterLine" }
      // { name: "text+lines" },
      // { name: "text+lines+markers" },
      // { name: "none" },
      // { name: "gauge" },
      // { name: "number" },
      // { name: "delta" },
      // { name: "number+delta" },
      // { name: "gauge+number" },
      // { name: "gauge+number+delta" },
      // { name: "gauge+delta" }
    ],
    SeriesStyle: [{ name: "normal" }, { name: "smooth" }],
    chartcolorview: false,
    ServiceToUrl: "",
    ServiceMethodType: "POST",
    ServiceHeaderobject: {},
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    Completedorder: false,
    processType: 0,
    Sampleselect: false,
    File: undefined,
  },
  // Loggeduser: {},
  // userworkflow: [],
  // navigation: "methodMainMenu",
  // fluidPage: false,
  // userData: {
  //   userName: "Administrator",
  //   role: 1,
  //   domain: "LocalDB",
  //   language: "en",
  //   site: { sitecode: 1, sitename: "Default", status: 1 },
  //   userSite: 1,
  //   error: "",
  // },
  hideMenu: {},
  masterData: {},
  visibility: true,
  transVisibility: true,
  fieldDetail: {},
  instrumentCategory: 2016, //primary key for 'General'
  saveAuditTrail: false,

  dataGridStatus: "",
  filterColumnName: "",
  searchColumnData: undefined,
  auditStatus: "",
  rawDataText: "",
  loginStatus: "",
  instrawdataurl: "",
  status: "",

  //status:"",
  loginUser: {
    usercode: 1,
    username: "Administrator",
    firstname: "Admin",
    lastname: "Admin",
    email: "admin@agaramtech.com",
    contactno: "4498765432",
    transstatusdetail: {
      transstatusdetailkey: 4,
      transstatus: { transstatuskey: 2, transstatusname: "Users" },
      statusmaster: {
        statuskey: 1,
        statusname: "Active",
        displayname: "Active",
      },
    },
    signImageUrl: null,
    userImageUrl: null,
    userimgname: null,
    signimgname: null,
    status: 0,
    createdby: {
      usercode: 1,
      username: "Administrator",
      firstname: "Admin",
      lastname: "Admin",
    },
    createddate: "2019-07-29T00:00:00Z",
  },
  loginSitePageList: [
    {
      pagekey: 43,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "MethodSetup",
      status: 1,
    },
    {
      pagekey: 44,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "MethodMaster",
      status: 1,
    },
    {
      pagekey: 45,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "Delimiters",
      status: 1,
    },
    {
      pagekey: 46,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "SampleSplit",
      status: 1,
    },
    {
      pagekey: 47,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "ParserSetup",
      status: 1,
    },
    {
      pagekey: 48,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "MethodDelimiter",
      status: 1,
    },
    {
      pagekey: 49,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "GeneralField",
      status: 1,
    },
    {
      pagekey: 51,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "CustomField",
      status: 1,
    },
    {
      pagekey: 52,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "InstrumentCategory",
      status: 1,
    },
    {
      pagekey: 53,
      module: {
        modulekey: 7,
        modulename: "MethodSetup",
        site: {
          sitecode: 1,
          sitename: "Default",
          status: 1,
        },
        status: 1,
      },
      pagename: "InstrumentMaster",
      status: 1,
    },
  ],
  loginUserSiteRole: {
    userrolekey: 1,
    usersite: {
      usersitekey: 1,
      users: {
        usercode: 1,
        username: "Administrator",
        firstname: "Admin",
        lastname: "Admin",
        email: "admin@agaramtech.com",
      },
      site: { sitecode: 1, sitename: "Default", status: 1 },
      defaultstatus: 1,
      status: 1,
      createdby: {
        usercode: 1,
        username: "Administrator",
        firstname: "Admin",
        lastname: "Admin",
      },
      createddate: "2019-07-29T00:00:00Z",
    },
    rolepolicy: {
      rolepolicykey: 3,
      role: {
        rolekey: 7,
        rolename: "Administrator",
        description: "Administrator Role",
        site: { sitecode: 1, sitename: "Default", status: 1 },
        status: 0,
        createdby: {
          usercode: 1,
          username: "Administrator",
          firstname: "Admin",
          lastname: "Admin",
        },
        createddate: "2019-11-21T00:00:00Z",
      },
      passcodepolicy: {
        policykey: 1,
        policyname: "Administrator",
        description: "Used for Administrator",
        maxpasscode: 20,
        nooffailedattempt: 3,
      },
      status: 0,
      createdby: {
        usercode: 1,
        username: "Administrator",
        firstname: "Admin",
        lastname: "Admin",
      },
      createddate: "2019-08-19T00:00:00Z",
    },

    passcode: "A@m1n",
    expirydate: "2020-01-13T10:32:57.017Z",
    transstatusdetail: {
      transstatusdetailkey: 4,
      transstatus: { transstatuskey: 2, transstatusname: "Users" },
      statusmaster: {
        statuskey: 1,
        statusname: "Active",
        displayname: "Active",
      },
    },
    clientip: "192.168.0.147",
    defaultstatus: 1,
    status: 1,
    createdby: {
      usercode: 1,
      username: "Administrator",
      firstname: "Admin",
      lastname: "Admin",
    },
    createddate: "2019-08-28T00:00:00Z",
  },
  loginInvalidAttempts: 0,
  isnotactivelogout: false,
  instrumentidparser: [],
  profileimages: []
};

const sheetDefaultContent =
  '{"activeSheet":"Sheet1","sheets":[{"name":"Sheet1","rows":[{"index": 0,"cells":[{"value":"","style":{},"index":"0"}]}],"columns":[],"selection":"A1:A1","activeCell":"A1:A1","frozenRows":0,"frozenColumns":0,"showGridLines":true,"gridLinesColor":null,"mergedCells":[],"hyperlinks":[],"defaultCellStyle":{"fontFamily":"Arial","fontSize":"12"},"drawings":[]},{"name":"Chart","rows":[{"index": 0,"cells":[{"value":"","style":{},"index":"0"}]}],"columns":[],"selection":"A1:A1","activeCell":"A1:A1","frozenRows":0,"frozenColumns":0,"showGridLines":true,"gridLinesColor":null,"mergedCells":[],"hyperlinks":[],"defaultCellStyle":{"fontFamily":"Arial","fontSize":"12"},"drawings":[]}],"names":[],"columnWidth":64,"rowHeight":20,"images":[],"charts":[],"plates":[],"tags":[],"Batchcoordinates":{"resultdirection":1,"parameters":[],"fields": []}}';

const pages = [
  { value: "home", name: "Home" },
  { value: "documents", name: "Documents" },
  { value: "dashboard", name: "Dashboard" },
  { value: "audithistory", name: "Audit history" },
  { value: "auditconfiguration", name: "Audit configuration" },
  { value: "cfrsettings", name: "CFR Settings" },
  { value: "testmaster", name: "Test master" },
  { value: "samplemaster", name: "Sample master" },
  { value: "unlockorder", name: "Unlock Order" },
  { value: "projectmaster", name: "Project master" },
  { value: "inventroy", name: "Inventroy" },
  { value: "instruments", name: "Instruments" },
  { value: "sdmsmappedinstruments", name: "SDMS Mapped Instruments" },
  { value: "delimiters", name: "delimiters" },
  { value: "methoddelimiters", name: "Method Delimiters" },
  { value: "methodmaster", name: "Method Master" },
  { value: "instrumentcategory", name: "Instrument category" },
  { value: "registertask", name: "Register task" },
  { value: "protocolorder", name: "Protocol order" },
  { value: "report", name: "Report" },
  { value: "sheetcreation", name: "Sheet creation" },
  { value: "protocols", name: "Protocols" },
  { value: "sheetmapping", name: "Sheet mapping" },
  { value: "domain", name: "Domain" },
  { value: "orderworkflow", name: "Order workflow" },
  { value: "passwordpolicy", name: "Password policy" },
  { value: "projectteam", name: "Project Team" },
  { value: "protocolworkflow", name: "Protocol workflow" },
  { value: "sheetworkflow", name: "Sheet workflow" },
  { value: "usergroup", name: "User group" },
  { value: "usermaster", name: "User master" },
  { value: "userrights", name: "User rights" },
  { value: "usersite", name: "User site" },
  { value: "registerorganisation", name: "Register organisation" },
  { value: "tenantlogin", name: "Tenant login" },
  { value: "tenantprofile", name: "Tenant profile" },
  { value: "administrator", name: "Administrator" },
  { value: "ad_organisation", name: "Administrator organisation" },
  { value: "ad_usermanagement", name: "Administrator usermanagement" },
  { value: "ad_adhelpdocument", name: "Administrator helpdocument" },
  { value: "ad_adhomedocument", name: "Administrator homedocument" },
  { value: "help", name: "Help" },
  { value: "fileviewer", name: "Fileviewer" },
  { value: "methodsetup", name: "Parser" },
  { value: "unitmaster", name: "Unitmaster" },
  { value: "sectionmaster", name: "Sectionmaster" },
  { value: "storagelocation", name: "Storagelocation" },
  { value: "materialcategory", name: "Materialcategory" },
  { value: "material", name: "Material" },
  { value: "materialinventory", name: "Materialinventory" },
  { value: "materialmanagement", name: "Materialmanagement" },
  { value: "logbook", name: "Logbook" },
];

let isMultitenant = 1;// set isBuild4MsSql = true on next line if you are taken build for ms-sql server for material inventory purpose
// set isBuild4MsSql = true on next line if you are taken build for ms-sql server for material inventory purpose

let isJQspread = false;
const isBuild4MsSql = false;

const isNewLinkSheet = true;

// if build was given for demo set true otherwise its false
const isAllowCopyPaste = false;

const releaseVersion = "6.7.5";

const isParserEnabled = true;

const isReportEnabled = true;

const isFileSave4Lims = false;

//reCAPTCHA sitekey
const SiteKey = "6LfUyNYpAAAAAImrHvZ2pSd40Z1v4kYa_rduyG1w";

const overridestylepuffloader = css`
  position: fixed;
  z-index: 99999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 50%;
  left: 50%;
  bottom: 0;
  right: 0;
  margin-top: -50px;
  margin-left: -50px;

  :before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const alphaarray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV'];

const lastValidationDate = {
  "static": 1,
  "label": "Last Validation Date & Time",
  "inputtype": "date",
  "displayname": {
    "en-US": "Last Validation Date & Time",
    "ru-RU": "Дата и время истечения срока действия",
    "tg-TG": "Санаи ба охир расидан ва вақт"
  }
};

const Protocolscreenenum = {
  protocoltemplate: 1,
  protocolorder: 2
}

const month = [
  // this.props.t("months.IDS_LBL_JAN", { param: "" }),
  // this.props.t("months.IDS_LBL_FEB", { param: "" }),
  // this.props.t("months.IDS_LBL_MAR", { param: "" }),
  // this.props.t("months.IDS_LBL_APR", { param: "" }),
  // this.props.t("months.IDS_LBL_MAY", { param: "" }),
  // this.props.t("months.IDS_LBL_JUN", { param: "" }),
  // this.props.t("months.IDS_LBL_JUL", { param: "" }),
  // this.props.t("months.IDS_LBL_AUG", { param: "" }),
  // this.props.t("months.IDS_LBL_SEP", { param: "" }),
  // this.props.t("months.IDS_LBL_OCT", { param: "" }),
  // this.props.t("months.IDS_LBL_NOV", { param: "" }),
  // this.props.t("months.IDS_LBL_DEC", { param: "" }),
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

const staticMaterialFields = [
  { "fieldname": "Material Type", "defaultstatus": 4, },
  { "fieldname": "Material Category", "defaultstatus": 4 },
  { "fieldname": "Material Name", "defaultstatus": 4 },
  { "fieldname": "Unit", "defaultstatus": 4 },
  { "fieldname": "Section", "defaultstatus": 4 },
  { "fieldname": "Quarantine", " defaultstatus": 4 },
  // { "fieldname": "Reusable", "defaultstatus": 3 },
  { "fieldname": "Expiry Validations", "defaultstatus": 4 },
  { "fieldname": "Remarks", "defaultstatus": 4 }
]

const staticEquipFields = [
  { "fieldname": "Equipment Type", "defaultstatus": 4, },
  { "fieldname": "Equipment Category", "defaultstatus": 4 },
  { "fieldname": "Equipment", "defaultstatus": 4 },
  { "fieldname": "Equipment Code", "defaultstatus": 4 },
  { "fieldname": "Equipment Make", "defaultstatus": 4 },
  { "fieldname": "Equipment Model", "defaultstatus": 4 },
  { "fieldname": "Equipment Lot No", "defaultstatus": 4 },
  { "fieldname": "Electrode No", "defaultstatus": 4 },
  { "fieldname": "Equipment Used", "defaultstatus": 4 },
  { "fieldname": "Maintanance Time Period", "defaultstatus": 4 },
  { "fieldname": "callibaration Time Period", "defaultstatus": 4 },
  { "fieldname": "Remarks", "defaultstatus": 4 },
]

const Marvinjs_Enable = false;
const countrieslist = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Democratic Republic)",
  "Congo (Republic)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini (Swaziland)",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast (Côte d'Ivoire)",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (North)",
  "Korea (South)",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
// const convertprotocolshorthandtooriginal = (item) => {

//   item.protocolordercode = item.pc;
//   item.Testcode = item.tc;
//   item.protoclordername = item.pn;
//   item.orderflag = item.of;
//   item.workflowcode = item.wc;
//   item.protocoltype = item.pt;
//   item.createdtimestamp = item.ct;
//   item.completedtimestamp = item.cot;
//   item.protocolmastername = item.pmn;
//   item.samplename = item.sn;
//   item.projectname = item.pn;
//   item.keyword = item.kw;
//   item.directorycode = item.dc;
//   item.lsprojectmaster = item.lpjm;
//   item.createby = item.cb;
//   item.assignedto = item.at;
//   item.lssamplemaster = item.lsm;
//   item.repositoryitemname = item.rin;
//   item.repositoryname = item.rn;
//   item.materialname = item.mn;
//   item.materialinventoryname = item.min;
//   item.directorycode = item.dc;
//   item.lsprotocolmaster = item.lpm;
//   item.approved = item.a;
//   item.rejected = item.r;
//   item.ordercancell = item.oc;
//   item.viewoption = item.vo;
//   item.orderstarted = item.os;
//   item.orderstartedby = item.osb;
//   item.orderstartedon = item.oso;
//   item.lockeduser = item.lu;
//   item.lockedusername = item.lun;
//   item.versionno = item.vn;
//   item.elnprotocolworkflow = item.lepw;
//   item.lsordernotification = item.lon;
//   item.lsautoregister = item.lar;
//   item.repeat = item.re;
//   item.sentforapprovel = item.sfa;
//   item.approvelaccept = item.aa;
//   item.autoregistercount = item.arc;
//   item.lsuserMaster = item.lum;

//   return item;
// };


const convertprotocolshorthandtooriginal = (item) => {
  const mappings = {
    pc: 'protocolordercode',
    tc: 'Testcode',
    pn: 'protoclordername',
    of: 'orderflag',
    wc: 'workflowcode',
    pt: 'protocoltype',
    ct: 'createdtimestamp',
    cot: 'completedtimestamp',
    pmn: 'protocolmastername',
    sn: 'samplename',
    pjn: 'projectname',
    kw: 'keyword',
    dc: 'directorycode',
    lpjm: 'lsprojectmaster',
    cb: 'createby',
    at: 'assignedto',
    lsm: 'lssamplemaster',
    rin: 'repositoryitemname',
    rn: 'repositoryname',
    mn: 'materialname',
    min: 'materialinventoryname',
    lpm: 'lsprotocolmaster',
    a: 'approved',
    r: 'rejected',
    oc: 'ordercancell',
    vo: 'viewoption',
    os: 'orderstarted',
    osb: 'orderstartedby',
    oso: 'orderstartedon',
    lu: 'lockeduser',
    lun: 'lockedusername',
    vn: 'versionno',
    lepw: 'elnprotocolworkflow',
    lon: 'lsordernotification',
    lar: 'lsautoregister',
    re: 'repeat',
    sfa: 'sentforapprovel',
    aa: 'approvelaccept',
    arc: 'autoregistercount',
    lum: 'lsuserMaster',
    cp: 'canuserprocess',
    isclone: 'isclone',
    tvno: 'templateversionno'
  };

  for (const [shorthand, full] of Object.entries(mappings)) {
    if (item[shorthand] !== undefined) {
      if (shorthand === "tvno" && (item[shorthand] !== undefined || item[full] !== undefined) && item?.protocolmastername !== undefined) {
        item.protocolmastername = item.protocolmastername + "_v" + (item[shorthand] ? item[shorthand] : item[full]);
      }
      item[full] = item[shorthand];
    }
  }

  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === 2 });

    if (sequenceobj && sequenceobj[0].sqv) {
      let seqview = sequenceobj[0].sqv;
      // if (seqview && seqview !== 1) {
      //   item.protoclordername = item.sid ? item.sid : item.sequenceid ? item.sequenceid : item.protoclordername;
      // }

      const newprotoclordername = item.sid ?? item.sequenceid ?? item.protoclordername ?? item.pn;
      if (newprotoclordername != null) {
        item.protoclordername = newprotoclordername;
      }
    }
  }

  return item;
};

const ProtocolSequence = (item) => {
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === 2 });

    if (sequenceobj && sequenceobj[0].sqv) {
      let seqview = sequenceobj[0].sqv;
      // if (seqview && seqview !== 1) {
      //   if(item.protoclordername !== undefined){
      //     item.protoclordername = item.sid ? item.sid : item.sequenceid ? item.sequenceid : item.protoclordername;
      //   }else{
      //     item.pn = item.sid ? item.sid : item.sequenceid ? item.sequenceid : item.protoclordername;
      //   }
      // }
      const newprotoclordername = item.sid ?? item.sequenceid ?? item.protoclordername ?? item.pn;
      if (newprotoclordername != null) {
        item.protoclordername !== undefined ?
          item.protoclordername = newprotoclordername :
          item.pn = newprotoclordername
      }
    }
  }
  return item;
}

const OrderSequence = (item) => {
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === 1 });

    if (sequenceobj && sequenceobj[0].sqv) {
      let seqview = sequenceobj[0].sqv;
      // if (seqview && seqview !== 1) {
      //   if(item.batchid !== undefined){
      //     item.batchid = item.sid ? item.sid : item.sequenceid ? item.sequenceid : item.batchid;
      //   }else{
      //     item.bi = item.sid ? item.sid : item.sequenceid ? item.sequenceid : item.batchid;
      //   }
      // }
      const newBatchId = item.sid ?? item.sequenceid ?? item.batchid ?? item.bi;
      if (newBatchId != null) {
        item.batchid !== undefined ?
          item.batchid = newBatchId :
          item.bi = newBatchId
      }
    }
  }
  return item;
}

const equipdefaultcheck = () => {
  let sequence = localStorage.getItem("elnsequence");

  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => seq.sc == 4);

    if (sequenceobj.length > 0 && sequenceobj[0].sqv) {
      return sequenceobj[0].sqv === 1;
    }
  }

  return false;
};

const orderdefaultcheck = () => {
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => seq.sc == 1);

    if (sequenceobj.length > 0 && sequenceobj[0].sqv) {
      return sequenceobj[0].sqv === 1;
    }
  }
  return false;
};

const protocoldefaultcheck = () => {
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => seq.sc == 2);

    if (sequenceobj.length > 0 && sequenceobj[0].sqv) {
      return sequenceobj[0].sqv === 1;
    }
  }
  return false;
};

const Equipmentsequenceid = (item) => {

  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc == 4 });
    if (Array.isArray(item)) {
      item?.map((item) => {
        if (sequenceobj && sequenceobj[0].sqv) {
          let seqview = sequenceobj[0].sqv;
          //if (seqview && seqview !== 1) {
          // item.sequipmentid = item.sequenceid ? item.sequenceid : item.sequipmentid;
          item.sequipmentid = item.sequenceid;
          //}
        }
      })
      return item;
    } else if (typeof item === 'object' && Object.keys(item).length > 0) {
      if (sequenceobj && sequenceobj[0].sqv) {
        let seqview = sequenceobj[0].sqv;
        //if (seqview && seqview !== 1) {
        // item.sequipmentid = item.sequenceid ? item.sequenceid : item.sequipmentid;
        item.sequipmentid = item.sequenceid;
        //}
      }
      return item;
    }
  }
}

const Samplesequenceid = (item) => {

  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc == 5 });
    item?.map((item) => {
      if (sequenceobj && sequenceobj[0].sqv) {
        let seqview = sequenceobj[0].sqv;
        if (seqview && seqview !== 1) {
          item.sampleid = item.sequenceid;
        }
      }
    })
    return item;
  }
}
const convertshorthandtooriginal = (item) => {

  item.batchcode = item.batchcode ? item.batchcode : item.bc;
  item.batchid = item.batchid ? item.batchid : item.bi;
  item.workflowcode = item.workflowcode ? item.workflowcode : item.wc;
  item.testname = item.testname ? item.testname : item.tn;
  item.filename = item.filename ? item.filename : item.fn;
  item.projectname = item.projectname ? item.projectname : item.pn;
  item.samplename = item.samplename ? item.samplename : item.sn;
  item.filetype = item.filetype ? item.filetype : item.ft;
  item.filecode = item.filecode ? item.filecode : item.fc;
  item.orderflag = item.orderflag ? item.orderflag : item.of;
  item.createdtimestamp = item.createdtimestamp ? item.createdtimestamp : item.ct;
  item.completedtimestamp = item.completedtimestamp ? item.completedtimestamp : item.cot;
  item.keyword = item.keyword ? item.keyword : item.kw;
  item.lsworkflow = item.lsworkflow ? item.lsworkflow : item.lsw;
  item.ordercancell = item.ordercancell ? item.ordercancell : item.oc;
  item.assignedto = item.assignedto ? item.assignedto : item.at;
  item.testcode = item.testcode ? item.testcode : item.tc;
  item.viewoption = item.viewoption ? item.viewoption : item.vo;
  item.createdby = item.createdby ? item.createdby : item.cb;
  item.approvelstatus = item.approvelstatus ? item.approvelstatus : item.as;
  item.lsordernotification = item.lsordernotification ? item.lsordernotification : item.on;
  item.ordersaved = item.ordersaved ? item.ordersaved : item.os;
  item.repeat = item.repeat ? item.repeat : item.r;
  item.lsautoregisterorders = item.lsautoregisterorders ? item.lsautoregisterorders : item.ar;
  item.sentforapprovel = item.sentforapprovel ? item.sentforapprovel : item.sfa;
  item.approvelaccept = item.approvelaccept ? item.approvelaccept : item.aa;
  item.autoregistercount = item.autoregistercount ? item.autoregistercount : item.arc;
  item.materialname = item.materialname ? item.materialname : item.mn;
  item.orderflag = item.orderflag ? item.orderflag : item.of;
  item.approvelstatus = item.approvelstatus ? item.approvelstatus : item.as;
  item.lockeduser = item.lockeduser ? item.lockeduser : item.lu;
  item.testcode = item.testcode ? item.testcode : item.tc;
  item.lssamplemaster = item.lssamplemaster ? item.lssamplemaster : item.lsm;
  item.lsprojectmaster = item.lsprojectmaster ? item.lsprojectmaster : item.lpm;
  item.filecode = item.filecode ? item.filecode : item.fc;
  item.filetype = item.filetype ? item.filetype : item.ft;
  item.lsuserMaster = item.lsuserMaster ? item.lsuserMaster : item.lum;
  item.batchid = item.batchid ? item.batchid : item.bi;
  item.batchcode = item.batchcode ? item.batchcode : item.bc;
  item.keyword = item.keyword ? item.keyword : item.kw;

  item.repositoryitemname = item.repositoryitemname ? item.repositoryitemname : item.rin;
  item.assignedto = item.assignedto ? item.assignedto : item.at;
  item.repositoryname = item.repositoryname ? item.repositoryname : item.rn;
  item.materialname = item.materialname ? item.materialname : item.mn;
  item.materialinventoryname = item.materialinventoryname ? item.materialinventoryname : item.min;
  item.directorycode = item.directorycode ? item.directorycode : item.dc;
  item.ordercancell = item.ordercancell ? item.ordercancell : item.oc;
  item.viewoption = item.viewoption ? item.viewoption : item.vo;
  item.lsordernotification = item.lsordernotification ? item.lsordernotification : item.lon;
  item.ordersaved = item.ordersaved ? item.ordersaved : item.os;
  item.repeat = item.repeat ? item.repeat : item.r;
  item.lsautoregisterorders = item.lsautoregisterorders ? item.lsautoregisterorders : item.laro;
  item.sentforapprovel = item.sentforapprovel ? item.sentforapprovel : item.sfa;
  item.approvelaccept = item.approvelaccept ? item.approvelaccept : item.ac;
  item.autoregistercount = item.autoregistercount ? item.autoregistercount : item.arc;
  item.canuserprocess = item.canuserprocess ? item.canuserprocess : item.cp;
  item.tittle = item.tittle ? item.tittle : item.tle;
  item.sitecode = item.sitecode ? item.sitecode : item.site;
  item.approved = item?.approved ? item.approved : item.app;
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === 1 });

    if (sequenceobj && sequenceobj[0].sqv) {
      let seqview = sequenceobj[0].sqv;
      //if (seqview && seqview !== 1) {
      //  item.batchid = item.sid ? item.sid : item.sequenceid ? item.sequenceid : item.batchid;

      const newBatchId = item.sid ?? item.sequenceid ?? item.batchid ?? item.bi;
      if (newBatchId != null) {
        item.batchid = newBatchId;
      }
    }
  }

  let sheetversionno = item.sheetversionno ? item.sheetversionno : item.svno;
  // if (sheetversionno !== undefined && sheetversionno !== null && sheetversionno !== "" && item.filename !== undefined && item.filename !== null && item.filename !== "") {
  //   item.filename = item.filename + ("-(v" + sheetversionno + ")");
  //   item.sheetversionno = sheetversionno;
  // }
  if (
    sheetversionno !== undefined &&
    sheetversionno !== null &&
    sheetversionno !== "" &&
    item.filename !== undefined &&
    item.filename !== null &&
    item.filename !== ""
  ) {
    item.filename = item.filename + `_v${sheetversionno}`;
    item.sheetversionno = sheetversionno;
  }


  return item;

}

const changesequenceidformaterial = (previousList, inventoryList, material) => {

  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === 3 });
    let sortedData = [...inventoryList].sort((a, b) => a.nmaterialinventorycode - b.nmaterialinventorycode);
    let invertoryorderno = previousList.length;
    sortedData.map((inventoryList) => {
      if (sequenceobj && sequenceobj[0].sqv) {
        let seqview = sequenceobj[0].sqv;
        // if (seqview && seqview !== 1) {
        inventoryList.sequenceid = material.sequenceid ? (material.sequenceid + sequenceobj[0].sep + (invertoryorderno + 1)) : inventoryList.sinventoryid;
        invertoryorderno++;
        //}
      }
    })
  }
  return inventoryList;
}

const inwardmaterialdefaultcheck = () => {
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => seq.sc == 3);

    if (sequenceobj.length > 0 && sequenceobj[0].sqv) {
      return sequenceobj[0].sqv === 1;
    }
  }
  return false;
};


const sequenceidchangeforinventory = (inventoryList) => {

  inventoryList.map((inventoryList) => {
    inventoryList.sequenceid = inventoryList.sequenceid ? inventoryList.sequenceid : inventoryList.sinventoryid;
  })
  return inventoryList;
}

const zeroPad = (num, places) => String(num).padStart(places, '0');
const genetrateidonsequence = (order, sequencecode, displayfield) => {
  let id = order[displayfield];
  let sequence = localStorage.getItem("elnsequence");
  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === sequencecode });

    if (sequenceobj && sequenceobj[0].sqf) {
      let seqview = sequenceobj[0].sqv;
      if (seqview && seqview !== 1) {

        if ((seqview === 2 && order.ase) || (seqview === 3 && order.sse)
          || (seqview === 4 && order.ose) || (seqview === 5 && order.tse)
          || (seqview === 6 && order.pse)) {
          id = "";
          let format = JSON.parse(sequenceobj[0].sqf);
          Object.keys(format).forEach(key => {
            if (key === "t") {
              id += format[key].t;
            }
            else if (key === "s") {
              let sequencenumber = seqview === 2 ? order.ase : seqview === 3 ?
                order.sse : seqview === 4 ? order.ose : seqview === 5 ? order.tse : seqview === 6 && order.pse;
              id += zeroPad(sequencenumber, format[key].l);
            }
          });
        }
      }
    }
  }

  return id;
};

const getsequenceoncode = (sequencecode) => {
  let sequence = localStorage.getItem("elnsequence");

  if (sequence) {
    let sequencearray = JSON.parse(sequence);
    let sequenceobj = sequencearray.filter(seq => { return seq.sc === sequencecode });

    return sequenceobj && sequenceobj.length > 0 && sequenceobj[0];
  }
  return undefined;
}


const getordertype = (ordertype) => {
  switch (ordertype) {
    case 2:
      return 'ELN';
    case 3:
      return 'RESEARCH';
    case 4:
      return 'EXCEL';
    case 5:
      return 'VALIDATE';
    default:
      return 'ELN';
  }
}

const getprotocolordertype = (ordertype) => {
  switch (ordertype) {
    case 1:
      return 'ELN PROTOCOL ORDERS';
    case 2:
      return 'DYNAMIC PROTOCOL ORDERS';
    default:
      return 'ELN PROTOCOL ORDERS';
  }
}

const modelList = () => {
  //main module
  let mainMenu = ["IDS_MDL_DASHBOARD",
    "IDS_MDL_ORDERS",
    "IDS_MDL_TEMPLATES",
    "IDS_MDL_INVENTORY",
    "IDS_MDL_LOGBOOK",
    "IDS_MDL_REPORTS",
    "IDS_MDL_SETUP",
    "IDS_MDL_AUDITTRAIL"
  ];
  //module with sup screens
  let modelLst = {
    "IDS_MDL_DASHBOARD": [
      {
        "accordianNavTitle": "IDS_MDL_DASHBOARD",
        "name": "IDS_SCN_DASHBOARD",
        "path": "/dashboard",
        "icon": ""
      },
    ],
    "IDS_MDL_ORDERS": [
      {
        "accordianNavTitle": "IDS_MDL_ORDERS",
        "name": "IDS_SCN_SHEETORDERS",
        "path": "/registertask",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_ORDERS",
        "name": "IDS_SCN_PROTOCOLORDERS",
        "path": "/Protocolorder",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_ORDERS",
        "name": "IDS_SCN_UNLOCKORDERS",
        "path": "/unlockorder",
        "icon": ""
      }
    ],
    "IDS_MDL_TEMPLATES": [
      {
        "accordianNavTitle": "IDS_MDL_TEMPLATES",
        "name": "IDS_SCN_SHEETTEMPLATE",
        "path": "/sheetcreation",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_TEMPLATES",
        "name": "IDS_SCN_PROTOCOLTEMPLATE",
        "path": "/protocols",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_TEMPLATES",
        "name": "IDS_SCN_TEMPLATEMAPPING",
        "path": "/sheetmapping",
        "icon": ""
      }
    ],
    "IDS_MDL_INVENTORY": [
      {
        "accordianNavTitle": "IDS_MDL_INVENTORY",
        "name": "IDS_SCN_MATERIALMGMT",
        "path": "/material",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_INVENTORY",
        "name": "IDS_SCN_MATERIALTYPEPARAMS",
        "path": "/materialtype",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_INVENTORY",
        "name": "IDS_SCN_EQUIPMENTMASTER",
        "path": "/instrumentsmaster",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_INVENTORY",
        "name": "IDS_SCN_EQUIPMENT",
        "path": "/instrumentstype",
        "icon": ""
      }
    ],
    "IDS_MDL_LOGBOOK": [
      {
        "accordianNavTitle": "IDS_MDL_LOGBOOK",
        "name": "IDS_SCN_LOGBOOK",
        "path": "/logbook",
        "icon": ""
      }
    ],
    "IDS_MDL_REPORTS": [
      {
        "accordianNavTitle": "IDS_MDL_REPORTS",
        "name": "IDS_SCN_REPORTS",
        "path": "/reportdesigner",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_REPORTS",
        "name": "IDS_SCN_REPORTVIEVER",
        "path": "/reportviewer",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_REPORTS",
        "name": "IDS_SCN_REPORTMAPPER",
        "path": "/reportMapping",
        "icon": ""
      }
    ],
    "IDS_MDL_SETUP": [
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_USERGROUP",
        "path": "/Usergroup",
        "icon": "",
        "supscreen": true,
      },
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_PROJECTMASTER",
        "path": "/Projectteam",
        "icon": "",
        "supscreen": true,
      },
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_TEMPLATEWORKFLOW",
        "path": "/Sheetworkflow",
        "icon": "",
        "supscreen": true,
      },
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_PASSWORDPOLICY",
        "path": "/Passwordpolicy",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_PARSER",
        "path": "/delimiters",
        "icon": "",
        "supscreen": true,
      },
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_BARCODEMASTER",
        "path": "/labelmaster",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_SETUP",
        "name": "IDS_SCN_SequenceGeneratorMASTER",
        "path": "/sequencegenerator",
        "icon": ""
      }
    ],
    "IDS_MDL_AUDITTRAIL": [
      {
        "accordianNavTitle": "IDS_MDL_AUDITTRAIL",
        "name": "IDS_SCN_AUDITTRAILHIS",
        "path": "/audithistory",
        "icon": ""
      },
      {
        "accordianNavTitle": "IDS_MDL_AUDITTRAIL",
        "name": "IDS_SCN_CFRSETTINGS",
        "path": "/cfrsettings",
        "icon": ""
      }
    ]
  }

  let returnObj = {};
  returnObj.mainMenu = mainMenu;
  returnObj.modelLst = modelLst;

  return returnObj;
}

export {
  lastValidationDate,
  initialreduxState,
  defalutreduxState,
  sheetDefaultContent,
  sdmsLink,
  isMultitenant,
  modelList,
  isNewLinkSheet,
  pages,
  override,
  releaseVersion,
  isParserEnabled,
  isReportEnabled,
  isFileSave4Lims, isBuild4MsSql, isAllowCopyPaste,
  overridestylepuffloader,
  alphaarray,
  Protocolscreenenum,
  month,
  staticMaterialFields,
  staticEquipFields,
  Marvinjs_Enable,
  SiteKey,
  countrieslist, convertprotocolshorthandtooriginal, convertshorthandtooriginal,
  getsequenceoncode,
  zeroPad,
  getordertype,
  getprotocolordertype,
  Equipmentsequenceid,
  Samplesequenceid,
  changesequenceidformaterial,
  sequenceidchangeforinventory,
  ProtocolSequence,
  OrderSequence,
  equipdefaultcheck,
  orderdefaultcheck,
  protocoldefaultcheck,
  inwardmaterialdefaultcheck,
  isJQspread

};

